import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentforweekendgatewaypune() {



const cardData =
{
  keyword: 'Bus on Rent for Weekend Getaway Pune',
  heading: 'Sanavi Travels: Bus on Rent for Weekend Getaway Pune',
  headingDescription: 'Sanavi Travels provides reliable and comfortable Bus on Rent for Weekend Getaway Pune services for families, friends, corporate teams, and groups planning short trips outside the city. With a wide range of AC, Non-AC, luxury, and mini buses, experienced drivers, flexible itineraries, and transparent pricing, we ensure smooth, safe, and enjoyable weekend travel from Pune to nearby tourist, leisure, and outstation destinations.',

  top: 'Top Weekend Getaway Experiences from Pune by Bus',

  "topPlaces": [
    {
      "title": "Hill Station Weekend Trips",
      "description": "Weekend hill station trips from Pune are among the most preferred travel choices for families, friends, and corporate teams looking to escape city life. Destinations such as Lonavala, Mahabaleshwar, Panchgani, and Bhandardara offer scenic landscapes, pleasant weather, waterfalls, viewpoints, and peaceful surroundings. Hiring a bus for hill station travel ensures the entire group travels together, enjoys the journey without driving stress, and experiences comfort on winding ghat roads. With professional drivers familiar with hilly terrains, well-maintained buses, sufficient luggage space, and comfortable seating, hill station weekend getaways become safe, relaxing, and memorable for travelers of all age groups."
    },
    {
      "title": "Pilgrimage Weekend Getaways",
      "description": "Pilgrimage destinations near Pune attract devotees throughout the year, making weekend trips to Shirdi, Bhimashankar, Pandharpur, Jejuri, Siddhatek, and other sacred places very popular. Bus rentals are ideal for such spiritual journeys as they provide safe, disciplined, and comfortable travel for elderly devotees, families, and large groups. Traveling together in a single bus allows devotees to maintain schedules, perform rituals on time, and avoid the inconvenience of multiple vehicles. With experienced drivers, flexible pickup points, and reliable service, pilgrimage weekend travel becomes peaceful and well-organized."
    },
    {
      "title": "Beachside Weekend Destinations",
      "description": "Beach destinations like Alibaug, Kashid, Murud, and nearby coastal spots are perfect for weekend relaxation. Bus on rent for beach getaways from Pune ensures hassle-free group travel with ample space for luggage, food supplies, and beach essentials. Travelers can enjoy coastal views, relax together, and avoid parking or navigation issues. Group bus travel also enhances bonding among friends, families, or colleagues, making the beach holiday experience enjoyable from the start of the journey until the return trip."
    },
    {
      "title": "Resort and Farm Stay Trips",
      "description": "Resorts, farm stays, and private villas near Pune are increasingly popular for weekend breaks, corporate outings, and family celebrations. Hiring a bus ensures coordinated arrival and departure, avoids delays, and provides comfort after long workweeks. Bus travel supports relaxed schedules, planned stops, and stress-free commuting to offbeat resort locations. With spacious seating and smooth rides, travelers reach their destination refreshed and ready to enjoy their stay."
    },
    {
      "title": "Corporate Offsite Weekends",
      "description": "Corporate teams often plan weekend offsites for training, bonding, and relaxation. Bus rentals offer disciplined and professional transport solutions for such trips, ensuring punctuality, safety, and smooth coordination. Employees can travel together, discuss plans en route, and arrive on time without individual travel hassles. Corporate-friendly buses support productivity, comfort, and professional image during offsite travel."
    },
    {
      "title": "Family Weekend Holidays",
      "description": "Family weekend holidays become more enjoyable when everyone travels together comfortably. Bus rentals eliminate the need for multiple cars, reduce travel fatigue, and ensure safety for children and senior citizens. With enough space to relax and enjoy conversations, family bus travel transforms the journey into a shared experience rather than just transportation."
    },
    {
      "title": "Friends Group Trips",
      "description": "Friends planning weekend getaways prefer buses as they offer cost-effective, fun, and convenient group travel. Music, shared conversations, planned stops, and scenic routes make the journey itself memorable. A hired bus ensures that everyone reaches the destination together, enhancing group bonding and enjoyment."
    },
    {
      "title": "Nature and Adventure Tours",
      "description": "Nature trails, trekking spots, camping locations, and adventure destinations around Pune require reliable transportation due to remote access and challenging routes. Hiring a bus with experienced drivers ensures safety, proper navigation, and timely travel. Adventure groups can focus on activities without worrying about vehicle coordination or driving responsibilities."
    },
    {
      "title": "Wedding-Related Weekend Travel",
      "description": "Wedding events often involve weekend travel to nearby destinations for ceremonies, receptions, or celebrations. Bus rentals simplify logistics by managing guest transportation efficiently. Comfortable buses ensure guests travel together, reach venues on time, and enjoy celebrations without transportation stress."
    },
    {
      "title": "Customized Outstation Weekend Routes",
      "description": "Many travelers prefer customized weekend routes to explore lesser-known destinations near Pune. Bus rentals allow flexible planning, route customization, and convenient scheduling. Whether it is a short leisure trip or a unique travel plan, customized bus travel ensures freedom, comfort, and control over the journey."
    }
  ],

  "services": [
    {
      "name": "Bus on Rent for Weekend Getaway Pune",
      "description": "Sanavi Travels offers comprehensive bus on rent services for weekend getaways from Pune, catering to families, friends, corporate teams, wedding groups, and leisure travelers. Our service focuses on comfort, safety, punctuality, and flexibility, ensuring that groups enjoy a smooth journey to nearby tourist destinations, hill stations, beaches, pilgrimage sites, and resorts. With a wide selection of buses, professional drivers, clean interiors, ample luggage space, and customizable travel plans, our weekend getaway bus service transforms short trips into relaxed and memorable experiences."
    },
    {
      "name": "AC Bus for Weekend Getaway Pune",
      "description": "AC buses are ideal for weekend getaways, especially during summer and long-distance travel. These buses provide cool interiors, comfortable seating, and a pleasant travel environment, allowing passengers to relax throughout the journey. AC buses are well-suited for families, corporate teams, and groups traveling to hill stations, beaches, or outstation destinations where comfort is a priority."
    },
    {
      "name": "Non AC Bus Rental Weekend Getaway Pune",
      "description": "Non AC buses offer a budget-friendly option for weekend trips without compromising on safety or reliability. These buses are suitable for short-distance getaways, group picnics, school outings, and economical travel plans. With proper ventilation, spacious seating, and experienced drivers, Non AC bus rentals ensure practical and cost-effective group travel."
    },
    {
      "name": "Luxury Bus Hire for Weekend Getaway Pune",
      "description": "Luxury buses provide premium travel experiences with enhanced interiors, pushback seats, improved suspension, and superior comfort. Ideal for corporate offsites, wedding groups, and premium leisure travel, luxury buses elevate weekend trips by offering a refined and relaxing journey from Pune to popular destinations."
    },
    {
      "name": "Mini Bus on Rent for Weekend Getaway Pune",
      "description": "Mini buses are perfect for small groups, nuclear families, and compact travel plans. They offer easy maneuverability, comfort, and cost efficiency for weekend trips. Mini bus rentals are commonly chosen for short getaways, resort stays, and friends’ trips from Pune."
    },
    {
      "name": "32 Seater Bus for Weekend Getaway Pune",
      "description": "32 seater buses are ideal for medium-sized groups such as extended families, corporate teams, or social groups. These buses provide sufficient seating space, balanced comfort, and economical travel for weekend getaways while keeping everyone together."
    },
    {
      "name": "35 Seater Bus Hire Weekend Getaway Pune",
      "description": "35 seater buses accommodate larger groups comfortably, making them suitable for weddings, corporate outings, and group tours. With spacious seating and professional drivers, these buses ensure smooth coordination and enjoyable weekend travel."
    },
    {
      "name": "Bus for Family Weekend Getaway Pune",
      "description": "Family-focused bus services prioritize safety, comfort, and convenience for travelers of all ages. With reliable schedules, smooth driving, and ample space, families can enjoy relaxed weekend journeys without travel stress."
    },
    {
      "name": "Bus for Corporate Weekend Getaway Pune",
      "description": "Corporate weekend getaway buses support professional travel needs, ensuring punctuality, discipline, and comfort. These services are ideal for offsites, team-building trips, and corporate retreats near Pune."
    },
    {
      "name": "Affordable Bus Rental Weekend Getaway Pune",
      "description": "Affordable bus rental options allow groups to plan weekend getaways within budget while still enjoying safe and reliable transportation. Transparent pricing and flexible packages help manage travel costs effectively."
    },
    {
      "name": "Best Bus Service Weekend Getaway Pune",
      "description": "Sanavi Travels is recognized for providing dependable, comfortable, and customer-focused weekend getaway bus services from Pune, trusted by families, corporates, and group travelers."
    },
    {
      "name": "Bus with Driver Weekend Getaway Pune",
      "description": "All weekend getaway buses come with experienced drivers who are familiar with popular routes, traffic patterns, and outstation travel requirements, ensuring safe and punctual journeys."
    },
    {
      "name": "Bus for Wedding Weekend Getaway Pune",
      "description": "Wedding-related weekend travel is simplified with dedicated bus services that manage guest transportation smoothly and efficiently, ensuring everyone reaches venues comfortably."
    },
    {
      "name": "Bus for Picnic Weekend Getaway Pune",
      "description": "Picnic groups benefit from bus rentals that offer convenience, comfort, and group coordination, making leisure outings enjoyable from start to finish."
    },
    {
      "name": "Outstation Bus for Weekend Getaway Pune",
      "description": "Outstation bus services support long-distance weekend travel with reliable vehicles, experienced drivers, and well-planned routes, ensuring stress-free journeys."
    }
  ],

  "tableData": [
    ["Weekend Getaway Bus Pune", "Outstation Travel"],
    ["AC Bus", "Non AC Bus"],
    ["Luxury Bus", "Mini Bus"],
    ["32 Seater", "35 Seater"],
    ["Family Trips", "Corporate Trips"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced Outstation Drivers", "WhyChoosedescription": "Drivers with route knowledge and safe driving practices." },
    { "WhyChooseheading": "Comfortable Long-Distance Travel", "WhyChoosedescription": "Spacious seating and smooth rides for weekend trips." },
    { "WhyChooseheading": "Flexible Travel Plans", "WhyChoosedescription": "Custom itineraries and scheduling support." },
    { "WhyChooseheading": "Well-Maintained Buses", "WhyChoosedescription": "Clean and regularly serviced vehicles." },
    { "WhyChooseheading": "Multiple Bus Options", "WhyChoosedescription": "Mini, standard, and luxury buses available." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear pricing without hidden charges." },
    { "WhyChooseheading": "Group-Friendly Travel", "WhyChoosedescription": "Entire group travels together comfortably." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is a reliable choice in Pune." }
  ]
};

const faqData = [
  { question: 'Do you provide buses for weekend getaways from Pune?', answer: 'Yes, Sanavi Travels offers dedicated weekend getaway bus rentals.' },
  { question: 'Are AC buses available for weekend trips?', answer: 'Yes, AC and Non AC buses are available.' },
  { question: 'Can we customize our weekend destination?', answer: 'Yes, routes and destinations are customizable.' },
  { question: 'Is the service suitable for families?', answer: 'Yes, it is ideal for family travel.' },
  { question: 'Do buses include drivers?', answer: 'Yes, all buses come with experienced drivers.' },
  { question: 'Are luxury buses available?', answer: 'Yes, luxury bus options are offered.' },
  { question: 'Is pricing transparent?', answer: 'Yes, we follow clear and upfront pricing.' },
  { question: 'Are buses safe for long-distance travel?', answer: 'Yes, buses are well-maintained and safe.' },
  { question: 'Can buses be used for corporate offsites?', answer: 'Yes, corporate trips are fully supported.' },
  { question: 'Can we book buses for picnic trips?', answer: 'Yes, picnic and leisure trips are supported.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Saurabh Joshi',
    feedback: 'Excellent weekend getaway bus service from Pune. Comfortable and well-managed.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Kulkarni',
    feedback: 'We booked a bus for a family weekend trip. Smooth journey and great service.',
    rating: 5
  }
];



























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










// const jsonData = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Bus on Rent for Weekend Getaway Pune - Sanavi Travels",
//   "description": "Sanavi Travels offers buses on rent for weekend getaways from Pune, including AC and Non-AC buses, luxury buses, 32-seater, 35-seater, and mini buses. Perfect for family trips, corporate outings, weddings, picnics, and outstation travel with professional drivers at affordable rates.",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.7",
//     "ratingCount": "10000+"
//   }
// };

const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/Bus-On-Rent-for-Weekend-Getaway-Pune#service",

  "name": "Bus on Rent for Weekend Getaway Pune",

  "serviceType": "Bus Rental for Weekend Trips",

  "description":
    "Sanavi Travels provides buses on rent in Pune for weekend getaways, family trips, group tours, corporate outings, picnics, college trips and short outstation journeys with professional drivers.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/Bus-On-Rent-for-Weekend-Getaway-Pune"
};





  return (
    <div>

<Helmet>
  <title>
    Bus on Rent for Weekend Getaway Pune | Group Bus Rental | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book a bus on rent in Pune for weekend getaways, family trips, group tours, corporate outings and picnics. Choose comfortable buses with professional drivers from Sanavi Travels."
  />

  <meta
    name="keywords"
    content="Bus on Rent for Weekend Getaway Pune, Weekend Bus Rental Pune, Bus Rental Pune, Weekend Trip Bus Pune, Group Bus Rental Pune, Bus Hire Pune, Weekend Getaway Bus Pune, Private Bus Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/Bus-On-Rent-for-Weekend-Getaway-Pune"
  />

  {/* Open Graph */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="Bus on Rent for Weekend Getaway Pune | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Rent a private bus from Pune for weekend getaways, family trips, group tours, corporate outings and picnics with professional drivers."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/Bus-On-Rent-for-Weekend-Getaway-Pune"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/bus-on-rent-for-weekend-getaway-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


{/* <Helmet>
  <title>
    Call : +91 7387507373 | Bus on Rent for Weekend Getaway Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses for weekend getaways from Pune with Sanavi Travels. AC & Non-AC buses, luxury buses, 32-seater, 35-seater, and mini buses for family trips, corporate outings, weddings, picnics, and outstation travel with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet> */}


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/bus-on-rent-for-weekend-getaway-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentforweekendgatewaypune;